/**
 * フォローユーザーの状態を保持し、フォローボタンのトグルとモーダルを出すモジュール
 */
import { User } from './user/User';
import { userStatus } from './user/status';
import { isFromFacebook, isLogined, toggleCookieFromFaceBook } from './cookies/cookies';
import { vmFacebookLoginModal } from './components';
import { sharePopup } from './sharePopup';
import { updateCount } from './followList/updateCount';
import { deleteExistingIcon } from './followList/deleteExistingIcon';
import { $elements } from './elements';

// const isMobile = $elements.followButton.getAttribute('data-mobile');

const followUser = () => {
  const companyId = Number($elements.companyId.value);

  let isFollowingAndFirstTime = false;

  const user = new User(isLogined());

  function updateButton (isFollowing) {
    $elements.followButton.classList[isFollowing ? 'add' : 'remove']('onchk');
    $elements.followButton.classList[isFollowing ? 'add' : 'remove']('button-blue');
    $elements.followButton.classList[isFollowing ? 'remove' : 'add']('button-white');
    $elements.followButton.textContent = isFollowing ? 'フォロー中' : 'フォロー';
  }

  function toggleButtonDisabled (isLoading) {
    $elements.followButton.classList[isLoading ? 'add' : 'remove']('is-loading');
  }

  function updateView (isFollowing) {
    updateButton(isFollowing);
    if (isFollowing) {
      sharePopup(companyId);
    }
    if (!isFollowingAndFirstTime) {
      updateCount(isFollowing);
    } else if (isFollowingAndFirstTime) {
      deleteExistingIcon(user.userId);
      updateCount(isFollowing);
      isFollowingAndFirstTime = false;
    }
  }

  function handleFollowButton () {
    switch (user.status) {
      case userStatus.loginedAndFollowing:
        user.unfollowCompany(companyId).then(() => {
          updateView(false);
        });
        break;
      case userStatus.loginedNotFollowing:
        user.followCompany(companyId).then(() => {
          updateView(true);
        });
        break;
      case userStatus.notLogined:
        // 非ログイン時にはログイン誘導モーダルを表示
        vmFacebookLoginModal.$data.isShow = true;
        break;
      default:
        return false;
    }
  }

  function addButtonEvent () {
    $elements.followButton.addEventListener('click', e => {
      handleFollowButton();
      e.preventDefault();
    });
  }

  // Facebookからの流入時
  function fromFacebook () {
    toggleCookieFromFaceBook(false);
    user.followCompany(companyId).then(() => {
      updateView(true);
      isFollowingAndFirstTime = true;
    });
  }

  function init () {
    toggleButtonDisabled(true);
    // ログイン時かFacebookからの流入時には企業IDを元にインスタンスを更新
    if (isLogined()) {
      user.updateUserInfo(companyId)
        .then(() => {
          // ログイン&フォロー時はボタンを活性に
          if (user.status === userStatus.loginedAndFollowing) {
            updateButton(true);
            isFollowingAndFirstTime = true;
            toggleCookieFromFaceBook(false);
          } else if (user.status !== userStatus.loginedAndFollowing && isFromFacebook()) {
            fromFacebook();
          } else {
            updateButton(false);
          }
          toggleButtonDisabled(false);
        });
    } else {
      toggleButtonDisabled(false);
    }
    addButtonEvent();
  }

  init();
};

window.addEventListener('load', () => {
  if ($elements.followButton !== null) {
    followUser();
  }
});
